import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Noticies from "@/pages/Noticies";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/atletes" element={<Noticies />} />
          <Route path="/noticies" element={<Noticies />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
